var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGtm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4928_143316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1308 34.5262L14.8818 28.4327L28.3023 14.728L34.7721 21.069L21.1308 34.5262Z",
    fill: "#8AB4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1575 7.58512L14.931 1.22778L1.31627 14.7136C-0.438756 16.4686 -0.438756 19.3139 1.31627 21.071L14.7265 34.569L21.0675 28.6372L10.8503 17.8923L21.1575 7.58512Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6822 14.8179L21.182 1.3178C19.425 -0.439266 16.5756 -0.439266 14.8185 1.3178C13.0615 3.07486 13.0615 5.92421 14.8185 7.68128L28.3187 21.1814C30.0758 22.9385 32.9252 22.9385 34.6822 21.1814C36.4393 19.4244 36.4393 16.575 34.6822 14.8179Z",
    fill: "#8AB4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8971 36.0009C20.3259 36.0009 22.2948 34.0319 22.2948 31.6031C22.2948 29.1743 20.3259 27.2053 17.8971 27.2053C15.4682 27.2053 13.4993 29.1743 13.4993 31.6031C13.4993 34.0319 15.4682 36.0009 17.8971 36.0009Z",
    fill: "#246FDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4928_143316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtm);
export default __webpack_public_path__ + "ff3c38e4b13d9bda8168e46182103005.svg";
export { ForwardRef as ReactComponent };